import gql from 'graphql-tag';

export const QUERY_PROPERTY_DETAILS = gql`
  query QUERY_PROPERTY_DETAILS($slug: String!, $dates: CheckinCheckout) {
    property(slug: $slug, dates: $dates) {
      id
      name
      connected
      rooms {
        id
        name
        description
        availableRooms
        guestsPerRoom
        active
        rate {
          symbol
          position
          value
          formatted
          name
        }
        ceilingRate {
          symbol
          position
          value
          formatted
          name
        }
        ceilingRateParams {
          percentageMaxMarkup
          percentageToTriggerMax
          percentageOnGDS
        }
        strikeoutRate {
          name
          formatted
          value
          type
        }
        nightlyRates {
          date
          price
          value
          rateCategory
        }
        availability # AVAILABLE, LIMITED, SOLD_OUT
        numRoomsAvail
        averageRateAfterCalculations {
          symbol
          position
          value
          formatted
          name
        }
      }
      timeZone
      callForPricing
      locale {
        currencyName
      }
    }
  }
`;

export const QUERY_PROPERTY_ROOMS = gql`
  query QUERY_PROPERTY_ROOMS($slug: String!, $dates: CheckinCheckout) {
    property(slug: $slug, dates: $dates) {
      id
      callForPricing
      rooms {
        id
        rate {
          symbol
          position
          value
          formatted
          name
        }
        ceilingRate {
          symbol
          position
          value
          formatted
          name
        }
        ceilingRateParams {
          percentageMaxMarkup
          percentageToTriggerMax
          percentageOnGDS
        }
        strikeoutRate {
          name
          formatted
          value
          type
        }
        availability # AVAILABLE, LIMITED, SOLD_OUT
        numRoomsAvail
        nightlyRates {
          date
          price
          value
          rateCategory
        }
        averageRateAfterCalculations {
          symbol
          position
          value
          formatted
          name
        }
      }
    }
  }
`;
